import PropTypes from 'prop-types';
import { useEffect } from 'react';
import DownloadSingleExtraFile from './downloadSingleExtraFile';
import DownloadAllExtraFiles from './downloadAllExtraFiles';
import ExtraPropTypes from '../extraPropType';
import { disableToolbarOverflow, enableToolbarOverflow } from '../../../utils/toolbarUtils';

export default function ExtrasPopoverContents({
  extras, pii, closePopover, adobeContentType,
}) {
  useEffect(() => {
    enableToolbarOverflow();
    return () => disableToolbarOverflow();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', closePopover);
    return () => window.removeEventListener('resize', closePopover);
  }, [closePopover]);

  return (
    extras.length === 1
      ? <DownloadSingleExtraFile file={extras[0]} pii={pii} adobeContentType={adobeContentType} />
      : <DownloadAllExtraFiles files={extras} pii={pii} adobeContentType={adobeContentType} />
  );
}

ExtrasPopoverContents.propTypes = {
  extras: PropTypes.arrayOf(PropTypes.shape(ExtraPropTypes)).isRequired,
  pii: PropTypes.string.isRequired,
  closePopover: PropTypes.func.isRequired,
  adobeContentType: PropTypes.string,
};

ExtrasPopoverContents.defaultProps = {
  adobeContentType: undefined,
};
